module.exports = __webpack_public_path__ + "static/img/robot.bc9c50e8.png";